import { get, post, put, destroy } from "./messageClient";

const noteService = {
  getTagList: () => get(`/api/note/taglist`),
  getLastNoteList: (limit, offset) =>
    get(`/api/note/getLast?limit=` + limit + `&offset=` + offset),
  createNote: (body) => post(`/api/note`, body),
  editNote: (body) => put(`/api/note`, body),
  deleteAllNotes: (body) => destroy(`/api/note`, { data: body }),
  filterNotes: (body) => post(`/api/note/filter`, body),
};

export default noteService;
